// export interface ApiOnboardingQuestionsPayload {
//   offer_hash: 'lily_test';
// }

export enum QUESTION_TYPE {
  skills = 0,
  radio = 1,
  checkbox = 2,
  identify = 3,
  email = 4,
}

interface QuestionAnswer {
  id: number;
  title: string;
  description?: string;
  image?: string;
  analytic_key: string;
  resetOther?: boolean;
}

export interface Question {
  id: number;
  type: QUESTION_TYPE;
  title: string;
  answers?: QuestionAnswer[];
  analytic_key: string;
}

export type ApiOnboardingQuestionsResponse = Question[];

export interface ApiSaveAnswerPayload {
  user_hash: string;
  question_id: number;
  answer_ids: number[];
}
